import Modal from "@mui/material/Modal";
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import AnimatedPage from '../../components/AnimatedPage';
import { toggleModal } from '../../reducers/modalReducer';
import ModalWrapper from "../../components/common/Modal/ModalWrapper";


const ManualAdd = () => {

    const dispatch = useDispatch();
    const navigation = useNavigate();
    const modal = useSelector((state) => state.modal);

    return (
        <div className='w100 df fdc px8rem'>
            <div className='df ais jcsb'>
                <div class='df fdc pt2rem'>
                    <Link to='/investor-dashboard#index?QualifiedLeads' className="w100 cp mb0-5rem">
                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 -3.41367e-07 8.19043 -3.49033e-07 8.01505C-3.56699e-07 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z" fill="#151313" />
                        </svg>
                    </Link>
                    <p className='w100 fs1-5rem fw300 c15'>Add Applicant</p>
                    <p className='w100 fs2rem fw500 c15'>Investor<span className='c4'>Match</span></p>
                </div>
                <img src={require('../../../images/investor-manual-add/manual-intro-ai.png')} alt="" />
            </div>
            <div className='pr w100 bg5 br15px df fdc aic p3rem' style={{ top: '-110px' }}>
                <p className='fs1-5rem c15 mb2rem'>How it works</p>
                <img class='w90' src={require('../../../images/investor-manual-add/manual-add-page.png')} alt="" />
                <p className='tac fs14px c12'>Diligentsia provides tools, not financial advice, to help match investors and companies. We do not receive commissions from investors and are not liable for the <br />
                    consequences of investment decisions by any party.  In completing your One<span className='c4'>Form</span> you confirm that you are happy for the information you provide to be shared <br />
                    with applicants on our database</p>
            </div>
            <div className='pr w100 df jcc' style={{ top: '-70px' }}>
                <button onClick={() => dispatch(toggleModal({ open: 'addApplicantPopup' }))} className='df jcc cp c1 bg4 fw400 fs1rem br38px w300px py0-5rem'>Let's Go!</button>
            </div>
        </div>
    );

}

export default ManualAdd;